import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const employeeRequestRoutes = [
	{
		key: "employee-request",
		exact: true,
		path: `${APP_PREFIX_PATH}/employee-request/list`,
		component: React.lazy(() => import("views/app-views/requests/employee-request/pages/EmployeeRequestList")),
	},
	{
		key: "employee-request-summary",
		exact: true,
		path: `${APP_PREFIX_PATH}/request/summary`,
		component: React.lazy(() => import("views/app-views/requests/employee-request/pages/RequestSummaryView")),
	},
];
